import { render, staticRenderFns } from "./TeamModal.vue?vue&type=template&id=19b7a142&"
import script from "./TeamModal.vue?vue&type=script&lang=js&"
export * from "./TeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b7a142')) {
      api.createRecord('19b7a142', component.options)
    } else {
      api.reload('19b7a142', component.options)
    }
    module.hot.accept("./TeamModal.vue?vue&type=template&id=19b7a142&", function () {
      api.rerender('19b7a142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/TeamModal.vue"
export default component.exports